import React from 'react'

import {ReactComponent as ReactLogo0} from '../svgs/element_icons/0.svg';

import {ReactComponent as ReactLogo1_1} from '../svgs/element_icons/1_1.svg';
import {ReactComponent as ReactLogo1_2} from '../svgs/element_icons/1_2.svg';
import {ReactComponent as ReactLogo1_3} from '../svgs/element_icons/1_3.svg';
import {ReactComponent as ReactLogo1_4} from '../svgs/element_icons/1_4.svg';
import {ReactComponent as ReactLogo1_5} from '../svgs/element_icons/1_5.svg';
import {ReactComponent as ReactLogo1_6} from '../svgs/element_icons/1_6.svg';
import {ReactComponent as ReactLogo1_7} from '../svgs/element_icons/1_7.svg';
import {ReactComponent as ReactLogo1_8} from '../svgs/element_icons/1_8.svg';
import {ReactComponent as ReactLogo1_9} from '../svgs/element_icons/1_9.svg';
import {ReactComponent as ReactLogo1_10} from '../svgs/element_icons/1_10.svg';
import {ReactComponent as ReactLogo1_11} from '../svgs/element_icons/1_11.svg';
import {ReactComponent as ReactLogo1_12} from '../svgs/element_icons/1_12.svg';
import {ReactComponent as ReactLogo1_13} from '../svgs/element_icons/1_13.svg';
import {ReactComponent as ReactLogo1_14} from '../svgs/element_icons/1_14.svg';
import {ReactComponent as ReactLogo1_15} from '../svgs/element_icons/1_15.svg';
import {ReactComponent as ReactLogo1_16} from '../svgs/element_icons/1_16.svg';
import {ReactComponent as ReactLogo1_17} from '../svgs/element_icons/1_17.svg';
import {ReactComponent as ReactLogo1_18} from '../svgs/element_icons/1_18.svg';
import {ReactComponent as ReactLogo1_19} from '../svgs/element_icons/1_19.svg';
import {ReactComponent as ReactLogo1_20} from '../svgs/element_icons/1_20.svg';
import {ReactComponent as ReactLogo1_21} from '../svgs/element_icons/1_21.svg';

import {ReactComponent as ReactLogo2_1} from '../svgs/element_icons/2_1.svg';
import {ReactComponent as ReactLogo2_2} from '../svgs/element_icons/2_2.svg';
import {ReactComponent as ReactLogo2_3} from '../svgs/element_icons/2_3.svg';
import {ReactComponent as ReactLogo2_4} from '../svgs/element_icons/2_4.svg';
import {ReactComponent as ReactLogo2_5} from '../svgs/element_icons/2_5.svg';
import {ReactComponent as ReactLogo2_6} from '../svgs/element_icons/2_6.svg';
import {ReactComponent as ReactLogo2_7} from '../svgs/element_icons/2_7.svg';
import {ReactComponent as ReactLogo2_8} from '../svgs/element_icons/2_8.svg';
import {ReactComponent as ReactLogo2_9} from '../svgs/element_icons/2_9.svg';
import {ReactComponent as ReactLogo2_10} from '../svgs/element_icons/2_10.svg';
import {ReactComponent as ReactLogo2_11} from '../svgs/element_icons/2_11.svg';
import {ReactComponent as ReactLogo2_12} from '../svgs/element_icons/2_12.svg';
import {ReactComponent as ReactLogo2_13} from '../svgs/element_icons/2_13.svg';
import {ReactComponent as ReactLogo2_14} from '../svgs/element_icons/2_14.svg';
import {ReactComponent as ReactLogo2_15} from '../svgs/element_icons/2_15.svg';
import {ReactComponent as ReactLogo2_16} from '../svgs/element_icons/2_16.svg';
import {ReactComponent as ReactLogo2_17} from '../svgs/element_icons/2_17.svg';
import {ReactComponent as ReactLogo2_18} from '../svgs/element_icons/2_18.svg';
import {ReactComponent as ReactLogo2_19} from '../svgs/element_icons/2_19.svg';
import {ReactComponent as ReactLogo2_20} from '../svgs/element_icons/2_20.svg';

import {ReactComponent as ReactLogo3_1} from '../svgs/element_icons/3_1.svg';
import {ReactComponent as ReactLogo3_2} from '../svgs/element_icons/3_2.svg';
import {ReactComponent as ReactLogo3_3} from '../svgs/element_icons/3_3.svg';
import {ReactComponent as ReactLogo3_4} from '../svgs/element_icons/3_4.svg';
import {ReactComponent as ReactLogo3_5} from '../svgs/element_icons/3_5.svg';
import {ReactComponent as ReactLogo3_6} from '../svgs/element_icons/3_6.svg';
import {ReactComponent as ReactLogo3_7} from '../svgs/element_icons/3_7.svg';
import {ReactComponent as ReactLogo3_8} from '../svgs/element_icons/3_8.svg';
import {ReactComponent as ReactLogo3_9} from '../svgs/element_icons/3_9.svg';
import {ReactComponent as ReactLogo3_10} from '../svgs/element_icons/3_10.svg';
import {ReactComponent as ReactLogo3_11} from '../svgs/element_icons/3_11.svg';
import {ReactComponent as ReactLogo3_12} from '../svgs/element_icons/3_12.svg';
import {ReactComponent as ReactLogo3_13} from '../svgs/element_icons/3_13.svg';
import {ReactComponent as ReactLogo3_14} from '../svgs/element_icons/3_14.svg';
import {ReactComponent as ReactLogo3_15} from '../svgs/element_icons/3_15.svg';
import {ReactComponent as ReactLogo3_16} from '../svgs/element_icons/3_16.svg';
import {ReactComponent as ReactLogo3_17} from '../svgs/element_icons/3_17.svg';
import {ReactComponent as ReactLogo3_18} from '../svgs/element_icons/3_18.svg';
import {ReactComponent as ReactLogo3_19} from '../svgs/element_icons/3_19.svg';
import {ReactComponent as ReactLogo3_20} from '../svgs/element_icons/3_20.svg';
import {ReactComponent as ReactLogo3_21} from '../svgs/element_icons/3_21.svg';
import {ReactComponent as ReactLogo3_22} from '../svgs/element_icons/3_22.svg';
import {ReactComponent as ReactLogo3_23} from '../svgs/element_icons/3_23.svg';
import {ReactComponent as ReactLogo3_24} from '../svgs/element_icons/3_24.svg';
import {ReactComponent as ReactLogo3_25} from '../svgs/element_icons/3_25.svg';
import {ReactComponent as ReactLogo3_26} from '../svgs/element_icons/3_26.svg';
import {ReactComponent as ReactLogo3_27} from '../svgs/element_icons/3_27.svg';

import {ReactComponent as ReactLogo4_1} from '../svgs/element_icons/4_1.svg';
import {ReactComponent as ReactLogo4_2} from '../svgs/element_icons/4_2.svg';
import {ReactComponent as ReactLogo4_3} from '../svgs/element_icons/4_3.svg';
import {ReactComponent as ReactLogo4_4} from '../svgs/element_icons/4_4.svg';
import {ReactComponent as ReactLogo4_5} from '../svgs/element_icons/4_5.svg';
import {ReactComponent as ReactLogo4_6} from '../svgs/element_icons/4_6.svg';
import {ReactComponent as ReactLogo4_7} from '../svgs/element_icons/4_7.svg';
import {ReactComponent as ReactLogo4_8} from '../svgs/element_icons/4_8.svg';
import {ReactComponent as ReactLogo4_9} from '../svgs/element_icons/4_9.svg';
import {ReactComponent as ReactLogo4_10} from '../svgs/element_icons/4_10.svg';
import {ReactComponent as ReactLogo4_11} from '../svgs/element_icons/4_11.svg';

import {ReactComponent as ReactLogo5_1} from '../svgs/element_icons/5_1.svg';
import {ReactComponent as ReactLogo5_2} from '../svgs/element_icons/5_2.svg';
import {ReactComponent as ReactLogo5_3} from '../svgs/element_icons/5_3.svg';
import {ReactComponent as ReactLogo5_4} from '../svgs/element_icons/5_4.svg';
import {ReactComponent as ReactLogo5_5} from '../svgs/element_icons/5_5.svg';
import {ReactComponent as ReactLogo5_6} from '../svgs/element_icons/5_6.svg';
import {ReactComponent as ReactLogo5_7} from '../svgs/element_icons/5_7.svg';
import {ReactComponent as ReactLogo5_8} from '../svgs/element_icons/5_8.svg';
import {ReactComponent as ReactLogo5_9} from '../svgs/element_icons/5_9.svg';
import {ReactComponent as ReactLogo5_10} from '../svgs/element_icons/5_10.svg';
import {ReactComponent as ReactLogo5_11} from '../svgs/element_icons/5_11.svg';
import {ReactComponent as ReactLogo5_12} from '../svgs/element_icons/5_12.svg';
import {ReactComponent as ReactLogo5_13} from '../svgs/element_icons/5_13.svg';

import {ReactComponent as ReactLogo6_1} from '../svgs/element_icons/6_1.svg';
import {ReactComponent as ReactLogo6_2} from '../svgs/element_icons/6_2.svg';
import {ReactComponent as ReactLogo6_3} from '../svgs/element_icons/6_3.svg';
import {ReactComponent as ReactLogo6_4} from '../svgs/element_icons/6_4.svg';
import {ReactComponent as ReactLogo6_5} from '../svgs/element_icons/6_5.svg';
import {ReactComponent as ReactLogo6_6} from '../svgs/element_icons/6_6.svg';
import {ReactComponent as ReactLogo6_7} from '../svgs/element_icons/6_7.svg';
import {ReactComponent as ReactLogo6_8} from '../svgs/element_icons/6_8.svg';
import {ReactComponent as ReactLogo6_9} from '../svgs/element_icons/6_9.svg';
import {ReactComponent as ReactLogo6_10} from '../svgs/element_icons/6_10.svg';
import {ReactComponent as ReactLogo6_11} from '../svgs/element_icons/6_11.svg';
import {ReactComponent as ReactLogo6_12} from '../svgs/element_icons/6_12.svg';
import {ReactComponent as ReactLogo6_13} from '../svgs/element_icons/6_13.svg';
import {ReactComponent as ReactLogo6_14} from '../svgs/element_icons/6_14.svg';
import {ReactComponent as ReactLogo6_15} from '../svgs/element_icons/6_15.svg';
import {ReactComponent as ReactLogo6_16} from '../svgs/element_icons/6_16.svg';
import {ReactComponent as ReactLogo6_17} from '../svgs/element_icons/6_17.svg';
import {ReactComponent as ReactLogo6_18} from '../svgs/element_icons/6_18.svg';
import {ReactComponent as ReactLogo6_19} from '../svgs/element_icons/6_19.svg';

import {ReactComponent as ReactLogo7_1} from '../svgs/element_icons/7_1.svg';
import {ReactComponent as ReactLogo7_2} from '../svgs/element_icons/7_2.svg';
import {ReactComponent as ReactLogo7_3} from '../svgs/element_icons/7_3.svg';
import {ReactComponent as ReactLogo7_4} from '../svgs/element_icons/7_4.svg';
import {ReactComponent as ReactLogo7_5} from '../svgs/element_icons/7_5.svg';
import {ReactComponent as ReactLogo7_6} from '../svgs/element_icons/7_6.svg';
import {ReactComponent as ReactLogo7_7} from '../svgs/element_icons/7_7.svg';
import {ReactComponent as ReactLogo7_8} from '../svgs/element_icons/7_8.svg';
import {ReactComponent as ReactLogo7_9} from '../svgs/element_icons/7_9.svg';

import {ReactComponent as ReactLogo8_1} from '../svgs/element_icons/8_1.svg';
import {ReactComponent as ReactLogo8_1_1} from '../svgs/element_icons/8_1_1.svg';
import {ReactComponent as ReactLogo8_1_2} from '../svgs/element_icons/8_1_2.svg';
import {ReactComponent as ReactLogo8_1_3} from '../svgs/element_icons/8_1_3.svg';
import {ReactComponent as ReactLogo8_1_4} from '../svgs/element_icons/8_1_4.svg';
import {ReactComponent as ReactLogo8_2} from '../svgs/element_icons/8_2.svg';
import {ReactComponent as ReactLogo8_2_1} from '../svgs/element_icons/8_2_1.svg';
import {ReactComponent as ReactLogo8_2_2} from '../svgs/element_icons/8_2_2.svg';
import {ReactComponent as ReactLogo8_2_3} from '../svgs/element_icons/8_2_3.svg';
import {ReactComponent as ReactLogo8_2_4} from '../svgs/element_icons/8_2_4.svg';
import {ReactComponent as ReactLogo8_3} from '../svgs/element_icons/8_3.svg';
import {ReactComponent as ReactLogo8_3_1} from '../svgs/element_icons/8_3_1.svg';
import {ReactComponent as ReactLogo8_3_2} from '../svgs/element_icons/8_3_2.svg';
import {ReactComponent as ReactLogo8_3_3} from '../svgs/element_icons/8_3_3.svg';
import {ReactComponent as ReactLogo8_3_4} from '../svgs/element_icons/8_3_4.svg';

import {ReactComponent as ReactLogo10_1} from '../svgs/element_icons/10_1.svg';
import {ReactComponent as ReactLogo10_2} from '../svgs/element_icons/10_2.svg';
import {ReactComponent as ReactLogo10_3} from '../svgs/element_icons/10_3.svg';
import {ReactComponent as ReactLogo10_4} from '../svgs/element_icons/10_4.svg';
import {ReactComponent as ReactLogo10_5} from '../svgs/element_icons/10_5.svg';
import {ReactComponent as ReactLogo10_6} from '../svgs/element_icons/10_6.svg';
import {ReactComponent as ReactLogo10_7} from '../svgs/element_icons/10_7.svg';
import {ReactComponent as ReactLogo10_8} from '../svgs/element_icons/10_8.svg';
import {ReactComponent as ReactLogo10_9} from '../svgs/element_icons/10_9.svg';
import {ReactComponent as ReactLogo10_10} from '../svgs/element_icons/10_10.svg';
import {ReactComponent as ReactLogo10_11} from '../svgs/element_icons/10_11.svg';
import {ReactComponent as ReactLogo10_12} from '../svgs/element_icons/10_12.svg';

export default function iconPaste(get_icon_id) {

  let found_svg
  
  switch (get_icon_id) {
    case '1_1':
      found_svg = <ReactLogo1_1 />; break;
    case '1_2':
      found_svg = <ReactLogo1_2 />; break;
    case '1_3':
      found_svg = <ReactLogo1_3 />; break;
    case '1_4':
      found_svg = <ReactLogo1_4 />; break;
    case '1_5':
      found_svg = <ReactLogo1_5 />; break;
    case '1_6':
      found_svg = <ReactLogo1_6 />; break;
    case '1_7':
      found_svg = <ReactLogo1_7 />; break;
    case '1_8':
      found_svg = <ReactLogo1_8 />; break;
    case '1_9':
      found_svg = <ReactLogo1_9 />; break;
    case '1_10':
      found_svg = <ReactLogo1_10 />; break;
    case '1_11':
      found_svg = <ReactLogo1_11 />; break;
    case '1_12':
      found_svg = <ReactLogo1_12 />; break;
    case '1_13':
      found_svg = <ReactLogo1_13 />; break;
    case '1_14':
      found_svg = <ReactLogo1_14 />; break;
    case '1_15':
      found_svg = <ReactLogo1_15 />; break;
    case '1_16':
      found_svg = <ReactLogo1_16 />; break;
    case '1_17':
      found_svg = <ReactLogo1_17 />; break;
    case '1_18':
      found_svg = <ReactLogo1_18 />; break;
    case '1_19':
      found_svg = <ReactLogo1_19 />; break;
    case '1_20':
      found_svg = <ReactLogo1_20 />; break;
    case '1_21':
      found_svg = <ReactLogo1_21 />; break;
    
    case '2_1':
      found_svg = <ReactLogo2_1 />; break;
    case '2_2':
      found_svg = <ReactLogo2_2 />; break;
    case '2_3':
      found_svg = <ReactLogo2_3 />; break;
    case '2_4':
      found_svg = <ReactLogo2_4 />; break;
    case '2_5':
      found_svg = <ReactLogo2_5 />; break;
    case '2_6':
      found_svg = <ReactLogo2_6 />; break;
    case '2_7':
      found_svg = <ReactLogo2_7 />; break;
    case '2_8':
      found_svg = <ReactLogo2_8 />; break;
    case '2_9':
      found_svg = <ReactLogo2_9 />; break;
    case '2_10':
      found_svg = <ReactLogo2_10 />; break;
    case '2_11':
      found_svg = <ReactLogo2_11 />; break;
    case '2_12':
      found_svg = <ReactLogo2_12 />; break;
    case '2_13':
      found_svg = <ReactLogo2_13 />; break;
    case '2_14':
      found_svg = <ReactLogo2_14 />; break;
    case '2_15':
      found_svg = <ReactLogo2_15 />; break;
    case '2_16':
      found_svg = <ReactLogo2_16 />; break;
    case '2_17':
      found_svg = <ReactLogo2_17 />; break;
    case '2_18':
      found_svg = <ReactLogo2_18 />; break;
    case '2_19':
      found_svg = <ReactLogo2_19 />; break;
    case '2_20':
      found_svg = <ReactLogo2_20 />; break;
    
    case '3_1':
      found_svg = <ReactLogo3_1 />; break;
    case '3_2':
      found_svg = <ReactLogo3_2 />; break;
    case '3_3':
      found_svg = <ReactLogo3_3 />; break;
    case '3_4':
      found_svg = <ReactLogo3_4 />; break;
    case '3_5':
      found_svg = <ReactLogo3_5 />; break;
    case '3_6':
      found_svg = <ReactLogo3_6 />; break;
    case '3_7':
      found_svg = <ReactLogo3_7 />; break;
    case '3_8':
      found_svg = <ReactLogo3_8 />; break;
    case '3_9':
      found_svg = <ReactLogo3_9 />; break;
    case '3_10':
      found_svg = <ReactLogo3_10 />; break;
    case '3_11':
      found_svg = <ReactLogo3_11 />; break;
    case '3_12':
      found_svg = <ReactLogo3_12 />; break;
    case '3_13':
      found_svg = <ReactLogo3_13 />; break;
    case '3_14':
      found_svg = <ReactLogo3_14 />; break;
    case '3_15':
      found_svg = <ReactLogo3_15 />; break;
    case '3_16':
      found_svg = <ReactLogo3_16 />; break;
    case '3_17':
      found_svg = <ReactLogo3_17 />; break;
    case '3_18':
      found_svg = <ReactLogo3_18 />; break;
    case '3_19':
      found_svg = <ReactLogo3_19 />; break;
    case '3_20':
      found_svg = <ReactLogo3_20 />; break;
    case '3_21':
      found_svg = <ReactLogo3_21 />; break;
    case '3_22':
      found_svg = <ReactLogo3_22 />; break;
    case '3_23':
      found_svg = <ReactLogo3_23 />; break;
    case '3_24':
      found_svg = <ReactLogo3_24 />; break;
    case '3_25':
      found_svg = <ReactLogo3_25 />; break;
    case '3_26':
      found_svg = <ReactLogo3_26 />; break;
    case '3_27':
      found_svg = <ReactLogo3_27 />; break;

    case '4_1':
      found_svg = <ReactLogo4_1 />; break;
    case '4_2':
      found_svg = <ReactLogo4_2 />; break;
    case '4_3':
      found_svg = <ReactLogo4_3 />; break;
    case '4_4':
      found_svg = <ReactLogo4_4 />; break;
    case '4_5':
      found_svg = <ReactLogo4_5 />; break;
    case '4_6':
      found_svg = <ReactLogo4_6 />; break;
    case '4_7':
      found_svg = <ReactLogo4_7 />; break;
    case '4_8':
      found_svg = <ReactLogo4_8 />; break;
    case '4_9':
      found_svg = <ReactLogo4_9 />; break;
    case '4_10':
      found_svg = <ReactLogo4_10 />; break;
    case '4_11':
      found_svg = <ReactLogo4_11 />; break;

    case '5_1':
      found_svg = <ReactLogo5_1 />; break;
    case '5_2':
      found_svg = <ReactLogo5_2 />; break;
    case '5_3':
      found_svg = <ReactLogo5_3 />; break;
    case '5_4':
      found_svg = <ReactLogo5_4 />; break;
    case '5_5':
      found_svg = <ReactLogo5_5 />; break;
    case '5_6':
      found_svg = <ReactLogo5_6 />; break;
    case '5_7':
      found_svg = <ReactLogo5_7 />; break;
    case '5_8':
      found_svg = <ReactLogo5_8 />; break;
    case '5_9':
      found_svg = <ReactLogo5_9 />; break;
    case '5_10':
      found_svg = <ReactLogo5_10 />; break;
    case '5_11':
      found_svg = <ReactLogo5_11 />; break;
    case '5_12':
      found_svg = <ReactLogo5_12 />; break;
    case '5_13':
      found_svg = <ReactLogo5_13 />; break;

    case '6_1':
      found_svg = <ReactLogo6_1 />; break;
    case '6_2':
      found_svg = <ReactLogo6_2 />; break;
    case '6_3':
      found_svg = <ReactLogo6_3 />; break;
    case '6_4':
      found_svg = <ReactLogo6_4 />; break;
    case '6_5':
      found_svg = <ReactLogo6_5 />; break;
    case '6_6':
      found_svg = <ReactLogo6_6 />; break;
    case '6_7':
      found_svg = <ReactLogo6_7 />; break;
    case '6_8':
      found_svg = <ReactLogo6_8 />; break;
    case '6_9':
      found_svg = <ReactLogo6_9 />; break;
    case '6_10':
      found_svg = <ReactLogo6_10 />; break;
    case '6_11':
      found_svg = <ReactLogo6_11 />; break;
    case '6_12':
      found_svg = <ReactLogo6_12 />; break;
    case '6_13':
      found_svg = <ReactLogo6_13 />; break;
    case '6_14':
      found_svg = <ReactLogo6_14 />; break;
    case '6_15':
      found_svg = <ReactLogo6_15 />; break;
    case '6_16':
      found_svg = <ReactLogo6_16 />; break;
    case '6_17':
      found_svg = <ReactLogo6_17 />; break;
    case '6_18':
      found_svg = <ReactLogo6_18 />; break;
    case '6_19':
      found_svg = <ReactLogo6_19 />; break;

    case '7_1':
      found_svg = <ReactLogo7_1 />; break;
    case '7_2':
      found_svg = <ReactLogo7_2 />; break;
    case '7_3':
      found_svg = <ReactLogo7_3 />; break;
    case '7_4':
      found_svg = <ReactLogo7_4 />; break;
    case '7_5':
      found_svg = <ReactLogo7_5 />; break;
    case '7_6':
      found_svg = <ReactLogo7_6 />; break;
    case '7_7':
      found_svg = <ReactLogo7_7 />; break;
    case '7_8':
      found_svg = <ReactLogo7_8 />; break;
    case '7_9':
      found_svg = <ReactLogo7_9 />; break;

    case '8_1':
      found_svg = <ReactLogo8_1 />; break;
    case '8_1_1':
      found_svg = <ReactLogo8_1_1 />; break;
    case '8_1_2':
      found_svg = <ReactLogo8_1_2 />; break;
    case '8_1_3':
      found_svg = <ReactLogo8_1_3 />; break;
    case '8_1_4':
      found_svg = <ReactLogo8_1_4 />; break;
    case '8_2':
      found_svg = <ReactLogo8_2 />; break;
    case '8_2_1':
      found_svg = <ReactLogo8_2_1 />; break;
    case '8_2_2':
      found_svg = <ReactLogo8_2_2 />; break;
    case '8_2_3':
      found_svg = <ReactLogo8_2_3 />; break;
    case '8_2_4':
      found_svg = <ReactLogo8_2_4 />; break;
    case '8_3':
      found_svg = <ReactLogo8_3 />; break;
    case '8_3_1':
      found_svg = <ReactLogo8_3_1 />; break;
    case '8_3_2':
      found_svg = <ReactLogo8_3_2 />; break;
    case '8_3_3':
      found_svg = <ReactLogo8_3_3 />; break;
    case '8_3_4':
      found_svg = <ReactLogo8_3_4 />; break;

    case '10_1':
      found_svg = <ReactLogo10_1 />; break;
    case '10_2':
      found_svg = <ReactLogo10_2 />; break;
    case '10_3':
      found_svg = <ReactLogo10_3 />; break;
    case '10_4':
      found_svg = <ReactLogo10_4 />; break;
    case '10_5':
      found_svg = <ReactLogo10_5 />; break;
    case '10_6':
      found_svg = <ReactLogo10_6 />; break;
    case '10_7':
      found_svg = <ReactLogo10_7 />; break;
    case '10_8':
      found_svg = <ReactLogo10_8 />; break;
    case '10_9':
      found_svg = <ReactLogo10_9 />; break;
    case '10_10':
      found_svg = <ReactLogo10_10 />; break;
    case '10_11':
      found_svg = <ReactLogo10_11 />; break;
    case '10_12':
      found_svg = <ReactLogo10_12 />; break;

    default:
      found_svg = <ReactLogo0 />; break;
  }

  return (found_svg)
}